import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AofComponent } from '../nridiy/aof/aof.component';
import { AddressComponent } from '../nridiy/address/address.component';
import { BankComponent } from './bank/bank.component';
import { CompleteComponent } from './complete/complete.component';
import { FatcaComponent } from '../nridiy/fatca/fatca.component';
import { PhotoComponent } from './photo/photo.component';
import { NomineeComponent } from '../nridiy/nominee/nominee.component';
import { RegisterComponent } from '../register/register.component';
import { OCIPIOComponent}  from '../nridiy/ocipio/ocipio.component';
import { PanComponent } from '../nridiy/pan/pan.component';
import { ForeignAddressComponent } from '../nridiy/foreign-address/foreign-address.component'
import { PassportDetailsComponent } from '../nridiy/passport-details/passport-details.component';
import { RIDetailsComponent } from './ri-details/ri-details.component';
import { SegmentsComponent } from '../nridiy/segments/segments.component';
import { VisaComponent } from '../nridiy/visa/visa.component';
import { SignatureComponent } from './signature/signature.component';
import { TermsdecComponent } from './termsdec/termsdec.component';

const routes: Routes = [
  { path: 'address', component: AddressComponent},
  { path: 'aof', component: AofComponent},
  { path: 'bank', component: BankComponent},
  { path: 'complete', component: CompleteComponent},
  { path: 'fatca', component: FatcaComponent},
  { path: 'foreign-address', component: ForeignAddressComponent},
  { path: 'photo', component: PhotoComponent},
  { path: 'nominee', component: NomineeComponent},
  { path: 'oci-pio', component: OCIPIOComponent },
  { path: 'pan', component: PanComponent},
  { path: 'passport', component: PassportDetailsComponent},
  { path: 'ridetails', component: RIDetailsComponent},
  { path: 'register', component: RegisterComponent},
  { path: 'segments', component: SegmentsComponent},
  { path: 'visa', component: VisaComponent},
  { path: 'signature', component: SignatureComponent},
  { path: 'terms', component: TermsdecComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes ,{
    scrollPositionRestoration : "top"
  })],
  exports: [RouterModule]
})
export class DiyRoutingModule { }